// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stats-dashboard-container {
  padding: 0;
  background: #F5F7FD;
  min-height: 100%;
}

.dashboard-header {
  padding: 20px 24px 16px 24px;
  background: #F5F7FD;
}

.dashboard-title {
  font-size: 24px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0;
  margin-bottom: 4px;
}

.dashboard-subtitle {
  font-size: 14px;
  color: #666;
  margin: 0;
}

.dashboard-filters {
  background: white;
  padding: 16px 20px;
  margin: 0 24px 0px 24px;
  border-radius: 8px;
  -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
          box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.filter-label {
  font-weight: 500;
  color: #333;
}

.dashboard-content {
  background: transparent;
  padding: 0;
}

/* Override global tab styles for dashboard - align with custom-app.css */

.dashboard-content .ant-tabs-content-holder {
  background: #F5F7FD;
  padding: 0 24px 24px 24px;
}

.dashboard-content .ant-tabs-tabpane {
  padding: 0;
}

/* Ensure tabs don't have bottom margin when next to refresh button */

.dashboard-content .ant-tabs-nav {
  margin-bottom: 0 !important;
}

/* Align refresh button with tabs */

.dashboard-content .ant-tabs-extra-content {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
}

.stats-card {
  height: 100%;
}

.stats-card .ant-card-body {
  padding: 20px;
}

.chart-card {
  margin-bottom: 20px;
  border-radius: 8px;
}

.chart-card .ant-card-head {
  border-bottom: 1px solid #f0f0f0;
}

.chart-card .ant-card-body {
  padding: 24px;
}

.performance-badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.performance-badge.excellent {
  background: #f6ffed;
  color: #52c41a;
  border: 1px solid #b7eb8f;
}

.performance-badge.good {
  background: #e6f7ff;
  color: #1890ff;
  border: 1px solid #91d5ff;
}

.performance-badge.warning {
  background: #fff7e6;
  color: #fa8c16;
  border: 1px solid #ffd591;
}

.performance-badge.poor {
  background: #fff1f0;
  color: #f5222d;
  border: 1px solid #ffa39e;
}

.stat-summary {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 16px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  margin-bottom: 20px;
}

.no-data-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  padding: 60px 20px;
  color: #999;
}

.no-data-container p {
  margin-top: 16px;
  font-size: 14px;
}

.loading-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  min-height: 400px;
}
`, "",{"version":3,"sources":["webpack://./pages/StatsDashboard/dashboard.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,gDAAwC;UAAxC,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,UAAU;AACZ;;AAEA,yEAAyE;;AACzE;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA,qEAAqE;;AACrE;EACE,2BAA2B;AAC7B;;AAEA,mCAAmC;;AACnC;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,SAAS;EACT,mBAAe;MAAf,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,iBAAiB;AACnB","sourcesContent":[".stats-dashboard-container {\r\n  padding: 0;\r\n  background: #F5F7FD;\r\n  min-height: 100%;\r\n}\r\n\r\n.dashboard-header {\r\n  padding: 20px 24px 16px 24px;\r\n  background: #F5F7FD;\r\n}\r\n\r\n.dashboard-title {\r\n  font-size: 24px;\r\n  font-weight: 600;\r\n  color: #1a1a1a;\r\n  margin: 0;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.dashboard-subtitle {\r\n  font-size: 14px;\r\n  color: #666;\r\n  margin: 0;\r\n}\r\n\r\n.dashboard-filters {\r\n  background: white;\r\n  padding: 16px 20px;\r\n  margin: 0 24px 0px 24px;\r\n  border-radius: 8px;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.filter-label {\r\n  font-weight: 500;\r\n  color: #333;\r\n}\r\n\r\n.dashboard-content {\r\n  background: transparent;\r\n  padding: 0;\r\n}\r\n\r\n/* Override global tab styles for dashboard - align with custom-app.css */\r\n.dashboard-content .ant-tabs-content-holder {\r\n  background: #F5F7FD;\r\n  padding: 0 24px 24px 24px;\r\n}\r\n\r\n.dashboard-content .ant-tabs-tabpane {\r\n  padding: 0;\r\n}\r\n\r\n/* Ensure tabs don't have bottom margin when next to refresh button */\r\n.dashboard-content .ant-tabs-nav {\r\n  margin-bottom: 0 !important;\r\n}\r\n\r\n/* Align refresh button with tabs */\r\n.dashboard-content .ant-tabs-extra-content {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.stats-card {\r\n  height: 100%;\r\n}\r\n\r\n.stats-card .ant-card-body {\r\n  padding: 20px;\r\n}\r\n\r\n.chart-card {\r\n  margin-bottom: 20px;\r\n  border-radius: 8px;\r\n}\r\n\r\n.chart-card .ant-card-head {\r\n  border-bottom: 1px solid #f0f0f0;\r\n}\r\n\r\n.chart-card .ant-card-body {\r\n  padding: 24px;\r\n}\r\n\r\n.performance-badge {\r\n  display: inline-block;\r\n  padding: 4px 12px;\r\n  border-radius: 12px;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n}\r\n\r\n.performance-badge.excellent {\r\n  background: #f6ffed;\r\n  color: #52c41a;\r\n  border: 1px solid #b7eb8f;\r\n}\r\n\r\n.performance-badge.good {\r\n  background: #e6f7ff;\r\n  color: #1890ff;\r\n  border: 1px solid #91d5ff;\r\n}\r\n\r\n.performance-badge.warning {\r\n  background: #fff7e6;\r\n  color: #fa8c16;\r\n  border: 1px solid #ffd591;\r\n}\r\n\r\n.performance-badge.poor {\r\n  background: #fff1f0;\r\n  color: #f5222d;\r\n  border: 1px solid #ffa39e;\r\n}\r\n\r\n.stat-summary {\r\n  display: flex;\r\n  gap: 16px;\r\n  flex-wrap: wrap;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.no-data-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 60px 20px;\r\n  color: #999;\r\n}\r\n\r\n.no-data-container p {\r\n  margin-top: 16px;\r\n  font-size: 14px;\r\n}\r\n\r\n.loading-container {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-height: 400px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
